import { PayloadAction, SerializedError } from '@reduxjs/toolkit';
import {
  TPersonalDataApplicationsStore,
  TPersonalDataTableResponse,
} from '~/store/processing-personal/types.ts';
import { TErrorResponse } from '~/store/types.ts';
import { personalDataApplicationsError } from '~/store/processing-personal/actions/actions.ts';

export const personalDataTableSubmitPending = (state: TPersonalDataApplicationsStore) => {
  state.pendingPersonalDataTableSubmit = true;
  state.loading = true;
  state.error = null;
};

export const personalDataTableSubmitFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TPersonalDataTableResponse>
) => {
  state.pendingPersonalDataTableSubmit = false;
  state.personalDataTableSubmit = action.payload;
  state.loading = false;
  state.error = null;
};

export const personalDataTableSubmitRejected = (
  state: TPersonalDataApplicationsStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  personalDataApplicationsError(state, action);
  state.pendingPersonalDataTableSubmit = false;
};

export const personalDataTableRevokePending = (state: TPersonalDataApplicationsStore) => {
  state.pendingPersonalDataTableRevoke = true;
  state.loading = true;
  state.error = null;
};

export const personalDataTableRevokeFulfilled = (
  state: TPersonalDataApplicationsStore,
  action: PayloadAction<TPersonalDataTableResponse>
) => {
  state.pendingPersonalDataTableRevoke = false;
  state.personalDataTableRevoke = action.payload;
  state.loading = false;
  state.error = null;
};

export const personalDataTableRevokeRejected = (
  state: TPersonalDataApplicationsStore,
  action: { error: SerializedError; payload?: TErrorResponse | unknown }
) => {
  personalDataApplicationsError(state, action);
  state.pendingPersonalDataTableRevoke = false;
};
